import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { map } from 'rxjs';

@Component({
    selector: 'formly-tags-field',
    template: `
    <label class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" *ngIf="to.label">{{ to.label }}</label>
    <ng-select
           groupBy="masterId"
           [selectableGroup]="true"
           [selectableGroupAsModel]="false"
           [closeOnSelect]="false"
           bindLabel="name"
           bindValue="id"
           [items]="items"
           [multiple]="true"
           [formControl]="formControl"
           [classList]="'bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500 mb-3'"
           >
        <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index">
            <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/>{{ (item.masterId === 0 ? "Other" : getMasterName(item.masterId)) | translate}}
        </ng-template>
        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <input id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/> {{item.name | translate}}
        </ng-template>
    </ng-select>
  `,
})
export class MultiType extends FieldType<FieldTypeConfig> {
    items!: any[];
    all!: any[];

    ngOnInit() {
        if (Array.isArray(this.to.options)) {
            this.to.options = this.items;
        } else {
            let options = this.to.options?.pipe(
                map((options: any[]) =>
                (this.all = options) &&
                    options.map((option: any) => {
                        if (option.masterId == null) {
                            option.masterId = 0;
                        }
                        return option;
                    })
                ),
                map((options: any[]) =>
                    options.filter((option: any) => ((option.observations!.length > 0 && option.masterId != 0) || (option.observations!.length > 0 && option.masterId == 0)))
                )
            );

            options?.subscribe((filteredOptions: any[]) => {
                this.items = filteredOptions;
            });
        }
    }

    getMasterName(id: number) {
        return this.all.find((item: any) => item.id === id)?.name;
    }
}
